(function ($) {
    $(function () {

    function syncBookingListItemHeights() {
        $('.booking-options').each(function () {
            const $bookingOptions = $(this);
            const $cards = $bookingOptions.find('.booking-options-card');

            // Reset heights before measuring again.
            $cards.find('li').css('min-height', '');

            let largestListCount = 0;

            $cards.each(function () {
                largestListCount = Math.max(
                    largestListCount,
                    $(this).find('li').length
                );
            });

            // Match each list item with the item in the same row.
            for (let index = 1; index <= largestListCount; index++) {
                const $rowItems = $cards.find(`li:nth-child(${index})`);
                let tallestHeight = 0;

                $rowItems.each(function () {
                    tallestHeight = Math.max(
                        tallestHeight,
                        this.getBoundingClientRect().height
                    );
                });

                $rowItems.css(
                    'min-height',
                    `${Math.ceil(tallestHeight)}px`
                );
            }
        });
    }

    let bookingOptionsResizeTimer;

    $(window).on('resize', function () {
        clearTimeout(bookingOptionsResizeTimer);

        bookingOptionsResizeTimer = setTimeout(function () {
            syncBookingListItemHeights();
        }, 100);
    });

    $(window).on('load', function () {
        syncBookingListItemHeights();
    });

    // Recalculate after web fonts have loaded.
    if (document.fonts) {
        document.fonts.ready.then(function () {
            syncBookingListItemHeights();
        });
    }


    });
})(jQuery);
